import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import axiosInstance from '../../../constants/axiosInstance';

export interface SensorConfig {
  modbusMisfireTotalizer: boolean;
  _id?: string;
  sensor: {
    _id: string;
    name: string;
    sensorTag: string;
  };
  referenceSensor?: {
    sensorTag: string;
    _id: string;
    name: string;
  };
  referenceSensorPurpose?: string;
  start?: number;
  end?: number;
  type?: string;
  wordOrder?: string;
  function?: string;
  scalingFactor?: number;
  bitIndex?: number;
  sensorTag?: string;
  sensorType?: string;
  isEnabled?: boolean;
  isModified?: boolean;
  isNewEntry?: boolean;
  isDeleted?: boolean;
}

export interface CreateOrUpdateDataLoggerPayload {
  dataLoggerId?: string;
  name: string;
  serialNumber: string;
  debug: boolean;
  plcBrand: string;
  pollingInterval: number;
  plcModel: string;
  asset: {
    _id: string;
    name: string;
  };
  modbusHost: string;
  modbusPort: number;
  unitIdReal: number;
  startAddressReal: number;
  registerCountReal: number;
  unitIdBool: number;
  startAddressBool: number;
  registerCountBool: number;
  sensorConfig: SensorConfig[];
}

interface CreateOrUpdateDataLoggerResponse {
  id: string;
  message: string;
  serialNumber: string;
}

const createOrUpdateDataLogger = async (payload: CreateOrUpdateDataLoggerPayload): Promise<CreateOrUpdateDataLoggerResponse> => {
  const { data } = await axiosInstance().post<CreateOrUpdateDataLoggerResponse>('/data-logger/createOrUpdateDataLogger', payload);
  return data;
};

export const useCreateOrUpdateDataLogger = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createOrUpdateDataLogger,
    onSuccess: (data) => {
      toast.success('Data Logger saved successfully!');
      queryClient.invalidateQueries({ queryKey: ['dataLoggers'] });
    },
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to save Data Logger');
    },
  });
}; 